const DE = {
  company: [
    "Gesellschaft mit beschränkter Haftung (GmbH)",
    "Unternehmergesellschaft (UG)",
    "gemeinnützige Gesellschaft mit beschränkter Haftung (gGmbH)"
  ],
  legalArrangement: [
    "Partnerschaftsgesellschaft (PartG)",
    "GmbH & Co. KG",
    "eingetragener Verein (e.V.)"
  ],
  soleProprietorship: [
    "Einzelunternehmen (e.K.)",
    "eingetragener Kaufmann (e. Kfm)",
    "eingetragene Kauffrau (e. Kffr)"
  ]
};
export {
  DE as default
};
